var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcons8Info1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    width: "25px",
    height: "25px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 25 8 C 15.611 8 8 15.611 8 25 C 8 34.389 15.611 42 25 42 C 34.389 42 42 34.389 42 25 C 42 15.611 34.389 8 25 8 z M 25 9 C 33.837 9 41 16.163 41 25 C 41 33.837 33.837 41 25 41 C 16.163 41 9 33.837 9 25 C 9 16.163 16.163 9 25 9 z M 25 17 C 24.448 17 24 17.448 24 18 C 24 18.552 24.448 19 25 19 C 25.552 19 26 18.552 26 18 C 26 17.448 25.552 17 25 17 z M 25 22 C 24.724 22 24.5 22.224 24.5 22.5 L 24.5 34.5 C 24.5 34.776 24.724 35 25 35 C 25.276 35 25.5 34.776 25.5 34.5 L 25.5 22.5 C 25.5 22.224 25.276 22 25 22 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Info1);
export default __webpack_public_path__ + "static/media/icons8-info (1).f186831694c84b01f1f044ad53e662db.svg";
export { ForwardRef as ReactComponent };